import { forwardRef, type PropsWithChildren } from 'react';

/**
 * Render a layout container that handle the margin for the different screen sizes
 *
 * See the related [Figma][figma] for more details.
 *
 * [figma]: https://www.figma.com/design/KAiRlBccr6bFYmKby9wQrR?node-id=16127-32959
 */
export const Layout = forwardRef<HTMLDivElement, PropsWithChildren>(
  ({ children }, ref) => (
    <div className="mx-m max-w-[1376px] desktop:mx-xl wide:mx-auto" ref={ref}>
      {children}
    </div>
  ),
);

Layout.displayName = 'Layout';
